export interface OriginMap {
  [propName: string]: string
}
export const pagePartOriginMap: OriginMap = {
  iwan: 'iwan.qq.com',
  weishi: 'weishi.qq.com',
  sports: 'sports.qq.com',
  yyb: 'yyb.qq.com',
  bbg: 'bbg.qq.com',
};
export const formalOriginMap: OriginMap = {
  iwanPrevious: 'https://act.iwan.qq.com',  // 之前没过接入层的爱玩业务接口域名。以下都是过爱玩接入层的接口域名
  iwan: 'https://api.iwan.qq.com',
  weishi: 'https://iwan.weishi.qq.com',
  sports: 'https://iwan.sports.qq.com',
  yyb: 'https://iwan.yyb.qq.com',
  bbg: 'https://iwan.bbg.qq.com',
};
export const testOriginMap: OriginMap = {
  iwanPrevious: 'https://apptest.iwan.qq.com',
  iwan: 'https://api-dev.iwan.qq.com',
  weishi: 'https://iwan-test.weishi.qq.com',
  sports: 'https://iwan-test.sports.qq.com',
  yyb: 'https://iwan-test.yyb.qq.com',
  bbg: 'https://iwan-test.bbg.qq.com',
};
export const originTypeMap = {
  iwanPrevious: 'iwanPrevious',
  iwan: 'iwan',
  weishi: 'weishi',
  sports: 'sports',
  yyb: 'yyb',
  bbg: 'bbg',
};

export enum OriginEnv {
  formal,
  test,
}

export enum IwanOriginType {
  normal,
  previous,
}

export const ApptestUrlTestValue = '2';
